import React, { useEffect, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import rootActions from 'actions/rootActions'
import userHasPrivs from '../../../Helper/Auth/userHasPrivs.js'

const SetLocationSubMenu = () => {
  const dispatch = useDispatch()
  const clinics = useSelector(state => state.appConfig.clinics) || []
  const currentLocation = useSelector(state => state.appConfig.CLINIC_LOCATION)
  const locationUpdateAllowed = userHasPrivs('local_settings_update')

  // Load clinics only if not already loaded
  useEffect(() => {

      dispatch(rootActions.xtractAPI('clinic', 'search', { is_null: 'deleted_at' }))

  }, [])

  // Sorted options including "All Locations"
  const locationSubMenuOptions = useMemo(() => {
    const sorted = clinics
      .map(clinic => ({
        name: clinic.name,
        value: Number(clinic.clinic_id)
      }))
      .sort((a, b) => a.name.localeCompare(b.name))
    return [{ name: 'All Locations', value: -1 }, ...sorted]
  }, [clinics])

  const handleLocationChange = useCallback((value) => {
    if (Number(value) !== Number(currentLocation)) {
      dispatch(rootActions.updateAppConfig('CLINIC_LOCATION', value))
    }
  }, [dispatch, currentLocation])

  return (
    <li className="dropdown-submenu"
      title={locationUpdateAllowed ? '' :
        'The Update Local Settings privilege within Set Location Tab is required to perform this action'}
      data-placement="left"
    >
      <a
        className="dropdown-toggle"
        id="setLocationDropDown"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true"
        role="button"
        aria-label="Set location"
        style={{
          cursor: locationUpdateAllowed ? 'pointer' : 'not-allowed',
          opacity: locationUpdateAllowed ? 1 : 0.2
        }}
      >
        <FontAwesomeIcon icon={['fas', 'clinic-medical']} />
        &nbsp;Set Location
      </a>
      <ul
        className="dropdown-menu dropdown-menu-right"
        aria-labelledby="set location menu"
      >
        {locationSubMenuOptions.map(option => {
          const isSelected = Number(currentLocation) === Number(option.value)
          return (
            <li key={option.value} className={isSelected ? 'active' : ''}
              style={{
                cursor: locationUpdateAllowed ? 'pointer' : 'not-allowed',
                opacity: locationUpdateAllowed ? 1 : 0.2
              }}
            >
              <a
                role="button"
                aria-label={`Switch to ${option.name}`}
                onClick={locationUpdateAllowed ? () => handleLocationChange(option.value) : null}
                style={{
                  display: 'flex', alignItems: 'center',
                  cursor: locationUpdateAllowed ? 'pointer' : 'not-allowed',
                  pointerEvents: locationUpdateAllowed ? 'auto' : 'none'
                }}
              >
                {isSelected && (
                  <FontAwesomeIcon icon={['fas', 'check']} className="text-success" />
                )}
                &nbsp;{option.name}
              </a>
            </li>
          )
        })}
      </ul>
    </li>
  )
}

export default SetLocationSubMenu
